import * as React from 'react'
// libs
import cn from 'classnames'
import './styles.css'
import ReCAPTCHA from 'react-google-recaptcha'
import { useForm } from 'react-hook-form'
// hooks
import { Themes, useTheme } from '../../../hooks/useTheme'
import { RECAPTCHA_SITE_KEY } from '../../../constants/env'
import Input from '../../ui/Input/input'
import { BACKEND_URL } from '../../../constants/env'

const ContactComponent = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm()

  const { theme } = useTheme()

  const isLightTheme = theme === Themes.LIGHT

  const recaptchaRef = React.useRef(null)

  const [captchaValue, setCaptchaValue] = React.useState(null)
  const [captchaError, setCaptchaError] = React.useState(false)
  const [submitError, setSubmitError] = React.useState(false)
  const [submitSuccess, setSubmitSuccess] = React.useState(false)

  const onSubmit = async (data) => {
    if (!captchaValue) {
      setCaptchaError(true) // set captcha empty error
      return
    }
    setSubmitError(false) // reset submit error
    setSubmitSuccess(false) // reset submit success

    const requestBody = {
      data: {
        email: data.email,
        phone: data.phone,
        message: data.message,
        lastName: data.lastName,
        firstName: data.firstName,
      },
      token: captchaValue,
    }

    try {
      const response = await fetch(`${BACKEND_URL}/api/contacts/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      })

      if (!response.ok) {
        setSubmitError(true)
        return
      }

      reset() // reset form after submit without errors
      recaptchaRef.current?.reset?.() // reset recaptcha
      setCaptchaValue(null) // reset captcha accepted value
      setSubmitSuccess(true) // show success message
    } catch (error) {
      setSubmitError(true)
    }
  }

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value)
    setCaptchaError(false)
  }

  const resetErrors = () => {
    setSubmitError(false)
    setSubmitSuccess(false)
  }

  return (
    <section className='contact-section'>
      <div className='contact-container'>
        <h2
          className={cn('contact-main-title', {
            'contact-main-title--light': isLightTheme,
          })}
        >
          Contact Us
        </h2>
        <form
          className='contact-form'
          onSubmit={handleSubmit(onSubmit)}
          onChange={resetErrors}
        >
          <div className='form-row'>
            <Input
              id='firstName'
              type='text'
              required={true}
              label='First Name'
              register={register}
              errors={errors}
              watch={watch}
            />
            <Input
              id='lastName'
              type='text'
              required={true}
              label='Last Name'
              register={register}
              errors={errors}
              watch={watch}
            />
          </div>

          <div className='form-row'>
            <Input
              id='phone'
              type='text'
              required={false}
              label='Phone Number'
              register={register}
              errors={errors}
              watch={watch}
            />
            <Input
              id='email'
              type='email'
              required={true}
              label='Email'
              register={register}
              errors={errors}
              watch={watch}
            />
          </div>

          <Input
            id='message'
            type='text'
            required={true}
            label='Message'
            register={register}
            errors={errors}
            watch={watch}
          />

          {RECAPTCHA_SITE_KEY && (
            <div className='recaptcha'>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                theme={isLightTheme ? 'light' : 'dark'}
                onChange={handleCaptchaChange}
              />
              {captchaError && (
                <p className='recaptcha-error-message'>
                  Please complete the reCAPTCHA
                </p>
              )}
            </div>
          )}

          <div>
            {submitError && (
              <p className='submit-message submit-error'>
                There was an error submitting your form. Please try again.
              </p>
            )}
            {submitSuccess && (
              <p className='submit-message submit-success'>
                Thank you for getting in touch.
              </p>
            )}
          </div>

          <button type='submit' className='contact-button'>
            Submit
          </button>
        </form>
      </div>
    </section>
  )
}

export default ContactComponent
